import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import { Box, Flex, Progress, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, VStack, useColorModeValue as mode, useToken } from '@chakra-ui/react';
import { flexRender, getCoreRowModel, getExpandedRowModel, getFacetedUniqueValues, getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import * as R from 'ramda';
import { Fragment, useEffect, useMemo, useState } from 'react';
import dataTestID from '../../constants/DataTestIndex';
import EmptyTableRow from '../common/EmptyTableRow';
import { ColumnFilter } from './Filter/ColumnFilter';
import { fuzzyFilter, getColumnProps } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var DEFAULT_ROW_SELECTION = {};
export var DEFAULT_GLOBAL_FILTER = '';
export var DEFAULT_COLUMN_FILTERS = [];
var Pagination = dynamic(function () {
  return import('./Pagination_v8');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('./Pagination_v8')];
    }
  }
});

var getShadow = function getShadow(isFirst) {
  return _defineProperty({
    content: '""',
    boxShadow: '5px 0 5px -6px rgba(0,0,0,.5) inset',
    width: '6px',
    height: '100%',
    position: 'absolute',
    transform: "scaleX(".concat(isFirst ? 1 : -1, ")"),
    top: 0
  }, isFirst ? 'right' : 'left', '-6px');
};

export var getStickyProps = function getStickyProps(_ref2) {
  var _ref3;

  var idx = _ref2.idx,
      isHeader = _ref2.isHeader,
      stickyID = _ref2.stickyID,
      isDisabled = _ref2.isDisabled,
      _lightGray = _ref2._lightGray;
  return _ref3 = {
    borderRightWidth: idx === stickyID ? 0 : 1,
    position: idx === stickyID ? 'sticky' : 'inherit'
  }, _defineProperty(_ref3, stickyID === 0 ? 'left' : 'right', idx === stickyID ? 0 : 'auto'), _defineProperty(_ref3, "_after", idx === stickyID ? getShadow(stickyID === 0) : {}), _defineProperty(_ref3, "color", _lightGray ? '#A0AEC0' : isDisabled ? '#A2A2A2' : 'blackAlpha.300'), _defineProperty(_ref3, "bg", isDisabled ? '#E7E7E7' : idx === stickyID && !isHeader && 'white'), _defineProperty(_ref3, "zIndex", 'docked'), _ref3;
};
export var TableContent = function TableContent(_ref4) {
  var _ref4$isDisabled = _ref4.isDisabled,
      isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled,
      columns = _ref4.columns,
      data = _ref4.data,
      textAlign = _ref4.textAlign,
      _ref4$pageSize = _ref4.pageSize,
      pageSize = _ref4$pageSize === void 0 ? 15 : _ref4$pageSize,
      _ref4$tableLayout = _ref4.tableLayout,
      tableLayout = _ref4$tableLayout === void 0 ? 'auto' : _ref4$tableLayout,
      _ref4$maxW = _ref4.maxW,
      maxW = _ref4$maxW === void 0 ? '' : _ref4$maxW,
      _ref4$maxH = _ref4.maxH,
      maxH = _ref4$maxH === void 0 ? '60vh' : _ref4$maxH,
      _ref4$wrap = _ref4.wrap,
      wrap = _ref4$wrap === void 0 ? false : _ref4$wrap,
      _ref4$isFlexHeight = _ref4.isFlexHeight,
      isFlexHeight = _ref4$isFlexHeight === void 0 ? false : _ref4$isFlexHeight,
      _ref4$hideHeader = _ref4.hideHeader,
      hideHeader = _ref4$hideHeader === void 0 ? false : _ref4$hideHeader,
      customColumnFilters = _ref4.customColumnFilters,
      onCustomColumnFiltersChange = _ref4.onCustomColumnFiltersChange,
      _ref4$enableMultiRowS = _ref4.enableMultiRowSelection,
      enableMultiRowSelection = _ref4$enableMultiRowS === void 0 ? true : _ref4$enableMultiRowS,
      columnVisibility = _ref4.columnVisibility,
      wrapperRef = _ref4.wrapperRef,
      _ref4$renderHeader = _ref4.renderHeader,
      renderHeader = _ref4$renderHeader === void 0 ? function () {
    return null;
  } : _ref4$renderHeader,
      _ref4$renderSubRows = _ref4.renderSubRows,
      renderSubRows = _ref4$renderSubRows === void 0 ? function () {
    return null;
  } : _ref4$renderSubRows,
      getSubRows = _ref4.getSubRows,
      sorting = _ref4.sorting,
      expanded = _ref4.expanded,
      _ref4$rowSelection = _ref4.rowSelection,
      rowSelection = _ref4$rowSelection === void 0 ? {} : _ref4$rowSelection,
      _ref4$globalFilter = _ref4.globalFilter,
      globalFilter = _ref4$globalFilter === void 0 ? '' : _ref4$globalFilter,
      globalFilterFn = _ref4.globalFilterFn,
      _ref4$colorScheme = _ref4.colorScheme,
      colorScheme = _ref4$colorScheme === void 0 ? 'brandScheme' : _ref4$colorScheme,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'medicine' : _ref4$variant,
      spacing = _ref4.spacing,
      onRowSelectionChange = _ref4.onRowSelectionChange,
      onGlobalFilterChange = _ref4.onGlobalFilterChange,
      onSortingChange = _ref4.onSortingChange,
      onExpandedChange = _ref4.onExpandedChange,
      _ref4$enableSorting = _ref4.enableSorting,
      enableSorting = _ref4$enableSorting === void 0 ? true : _ref4$enableSorting,
      _ref4$enablePaginatio = _ref4.enablePagination,
      enablePagination = _ref4$enablePaginatio === void 0 ? true : _ref4$enablePaginatio,
      _ref4$enablePaginatio2 = _ref4.enablePaginationOnlyBottom,
      enablePaginationOnlyBottom = _ref4$enablePaginatio2 === void 0 ? false : _ref4$enablePaginatio2,
      _ref4$enablePaginatio3 = _ref4.enablePaginationOnlyTop,
      enablePaginationOnlyTop = _ref4$enablePaginatio3 === void 0 ? false : _ref4$enablePaginatio3,
      _ref4$showTotalAmount = _ref4.showTotalAmount,
      showTotalAmount = _ref4$showTotalAmount === void 0 ? false : _ref4$showTotalAmount,
      _ref4$stickyFirstColu = _ref4.stickyFirstColumn,
      stickyFirstColumn = _ref4$stickyFirstColu === void 0 ? false : _ref4$stickyFirstColu,
      _ref4$stickyLastColum = _ref4.stickyLastColumn,
      stickyLastColumn = _ref4$stickyLastColum === void 0 ? false : _ref4$stickyLastColum,
      _ref4$testID = _ref4.testID,
      testID = _ref4$testID === void 0 ? dataTestID.generalTable.Table : _ref4$testID,
      _ref4$loading = _ref4.loading,
      loading = _ref4$loading === void 0 ? false : _ref4$loading;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var items = useMemo(function () {
    return data !== null && data !== void 0 ? data : [];
  }, [data]);

  var _useState = useState([]),
      columnFilters = _useState[0],
      setColumnFilters = _useState[1];

  var dockedZIndex = useToken('zIndices', 'docked');

  var _useState2 = useState({
    pageIndex: 0,
    pageSize: pageSize
  }),
      pagination = _useState2[0],
      setPagination = _useState2[1];

  var handlePageChange = useMemo(function () {
    return R.compose(setPagination, R.assoc('pageIndex'));
  }, []);
  var table = useReactTable({
    columns: columns,
    data: items,
    globalFilterFn: globalFilterFn !== null && globalFilterFn !== void 0 ? globalFilterFn : fuzzyFilter,
    meta: {
      isDisabled: isDisabled
    },
    state: {
      columnVisibility: columnVisibility,
      rowSelection: rowSelection,
      globalFilter: globalFilter,
      pagination: pagination,
      columnFilters: customColumnFilters !== null && customColumnFilters !== void 0 ? customColumnFilters : columnFilters,
      sorting: sorting,
      expanded: expanded
    },
    enableColumnFilters: true,
    enableRowSelection: !!rowSelection,
    enableGlobalFilter: !!globalFilter,
    enableMultiRowSelection: enableMultiRowSelection,
    onRowSelectionChange: onRowSelectionChange,
    onGlobalFilterChange: onGlobalFilterChange,
    onColumnFiltersChange: onCustomColumnFiltersChange !== null && onCustomColumnFiltersChange !== void 0 ? onCustomColumnFiltersChange : setColumnFilters,
    onSortingChange: onSortingChange,
    onExpandedChange: onExpandedChange,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: enableSorting && sorting ? getSortedRowModel() : undefined,
    getPaginationRowModel: enablePagination && getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getSubRows: getSubRows
  }); // set to last page when filter change and current page index is out of range

  useEffect(function () {
    if (!enablePagination) {
      return;
    }

    var filteredRows = table.getFilteredRowModel().rows;
    var totalPage = Math.ceil(filteredRows.length / pageSize);

    if (pagination.pageIndex >= totalPage) {
      handlePageChange(Math.max(totalPage - 1, 0));
    }
  }, [handlePageChange, table, columnFilters, globalFilter, enablePagination, pageSize, pagination.pageIndex]);
  var columnsLength = columns.length - Object.values(columnVisibility !== null && columnVisibility !== void 0 ? columnVisibility : {}).filter(function (value) {
    return !value;
  }).length;
  var dataCount = items.length;
  var filteredRows = table.getFilteredRowModel().rows;
  var isFiltered = dataCount !== filteredRows.length;
  var displayDataCount = "".concat(filteredRows.length).concat(isFiltered ? ' / ' + dataCount : '');
  var rows = table.getRowModel().rows.filter(function (row) {
    var _row$original;

    return !row._destroy && !((_row$original = row.original) !== null && _row$original !== void 0 && _row$original._destroy);
  });
  return /*#__PURE__*/_jsx(VStack, {
    maxW: maxW,
    w: "100%",
    h: isFlexHeight ? 'full' : '',
    my: "0",
    p: "0",
    alignItems: "start",
    overflow: "auto",
    e2eid: "Table_TableContent_v8_VStack",
    children: /*#__PURE__*/_jsxs(Stack, {
      overflow: "hidden",
      position: "relative",
      shadow: wrap ? ' 0px 4px 24px rgba(0, 0, 0, 0.06)' : '',
      p: wrap ? '4' : '0',
      rounded: "md",
      w: "full",
      h: isFlexHeight ? 'full' : '',
      bgColor: "white",
      spacing: spacing,
      e2eid: "Table_TableContent_v8_Stack",
      children: [renderHeader(), table.getFilteredRowModel().rows.length > 0 && (showTotalAmount || enablePagination) && /*#__PURE__*/_jsxs(Flex, {
        bgColor: "white",
        w: "full",
        direction: "row",
        justify: "space-between",
        rounded: "md",
        p: 0,
        e2eid: "Table_TableContent_v8_Flex",
        children: [showTotalAmount && /*#__PURE__*/_jsx(Text, {
          "data-test": dataTestID.generalTable.ListItemCount,
          color: mode('gray.600', 'gray.400'),
          fontSize: "sm",
          e2eid: "Table_TableContent_v8_Text",
          children: t('common:table.totalCount', "\u5171 ".concat(displayDataCount, " \u7B46\u8CC7\u6599"), {
            total: displayDataCount
          })
        }), enablePagination && !enablePaginationOnlyBottom && /*#__PURE__*/_jsx(Pagination, {
          colorScheme: colorScheme,
          table: table,
          onPageChange: handlePageChange,
          e2eid: "Table_TableContent_v8_Pagination"
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        overflow: loading ? 'hidden' : 'auto',
        position: "relative",
        e2eid: "Table_TableContent_v8_Box",
        children: [loading && /*#__PURE__*/_jsx(Box, {
          zIndex: 99,
          top: 0,
          left: 0,
          right: 0,
          pos: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          borderTopRadius: "md",
          overflow: "hidden",
          e2eid: "Table_TableContent_v8_Box_6",
          children: /*#__PURE__*/_jsx(Progress, {
            size: "xs",
            isIndeterminate: true,
            e2eid: "Table_TableContent_v8_Progress"
          })
        }), /*#__PURE__*/_jsx(TableContainer, {
          position: "relative",
          ref: wrapperRef,
          rounded: "md",
          overflowY: "auto",
          overflow: "auto",
          borderWidth: 1,
          borderColor: "gray.300",
          maxH: maxH,
          e2eid: "Table_TableContent_v8_TableContainer",
          children: /*#__PURE__*/_jsxs(Table, {
            layout: tableLayout,
            "data-test": testID,
            variant: variant,
            colorScheme: colorScheme,
            maxW: "100%",
            bgColor: "white",
            shadow: " 0px 4px 24px rgba(65, 29, 29, 0.06)",
            w: "100%",
            e2eid: "Table_TableContent_v8_Table",
            children: [!hideHeader && /*#__PURE__*/_jsx(Thead, {
              zIndex: dockedZIndex + 1,
              e2eid: "Table_TableContent_v8_Thead",
              children: table.getHeaderGroups().map(function (headerGroup) {
                return /*#__PURE__*/_jsx(Tr, {
                  e2eid: "Table_TableContent_v8_Tr",
                  children: headerGroup.headers.map(function (header, idx) {
                    var _header$column$column, _header$column$column2, _header$column$column3, _header$column$column4, _asc$desc, _header$column$column5, _header$column$column6, _header$column$column7;

                    var stickyID = stickyFirstColumn ? 0 : stickyLastColumn ? columnsLength - 1 : -1;
                    var canSort = header.column.getCanSort();
                    return /*#__PURE__*/_createElement(Th, _objectSpread(_objectSpread({
                      colSpan: header.colSpan
                    }, stickyFirstColumn || stickyLastColumn ? getStickyProps({
                      idx: idx,
                      isHeader: true,
                      stickyID: stickyID,
                      isDisabled: isDisabled
                    }) : getColumnProps({
                      isDisabled: isDisabled
                    })), {}, {
                      key: header.id,
                      px: 2,
                      py: 1.5,
                      textAlign: (_header$column$column = header.column.columnDef.align) !== null && _header$column$column !== void 0 ? _header$column$column : 'left',
                      style: {
                        width: ((_header$column$column2 = header.column.columnDef) === null || _header$column$column2 === void 0 ? void 0 : _header$column$column2.width) || header.getSize(),
                        maxWidth: (_header$column$column3 = header.column.columnDef) === null || _header$column$column3 === void 0 ? void 0 : _header$column$column3.maxWidth,
                        minWidth: (_header$column$column4 = header.column.columnDef) === null || _header$column$column4 === void 0 ? void 0 : _header$column$column4.minWidth,
                        textAlign: textAlign
                      },
                      e2eid: "Table_TableContent_v8_Th"
                    }), /*#__PURE__*/_jsxs(Box, {
                      display: "flex",
                      flexDir: "column",
                      rowGap: 1,
                      justifyContent: "space-between",
                      e2eid: "Table_TableContent_v8_Box",
                      children: [/*#__PURE__*/_jsxs(Box, {
                        display: "flex",
                        alignItems: "center",
                        columnGap: 1,
                        justifyContent: textAlign !== 'center' ? textAlign === 'right' ? 'flex-end' : 'flex-start' : textAlign,
                        cursor: canSort ? 'pointer' : 'auto',
                        onClick: header.column.getToggleSortingHandler(),
                        e2eid: "Table_TableContent_v8_Box_14",
                        children: [header.isPlaceholder ? null : flexRender(header.column.columnDef.header, _objectSpread(_objectSpread({}, header.getContext()), {}, {
                          isDisabled: isDisabled
                        })), (_asc$desc = {
                          asc: /*#__PURE__*/_jsx(TriangleUpIcon, {
                            e2eid: "Table_TableContent_v8_TriangleUpIcon"
                          }),
                          desc: /*#__PURE__*/_jsx(TriangleDownIcon, {
                            e2eid: "Table_TableContent_v8_TriangleDownIcon"
                          })
                        }[header.column.getIsSorted()]) !== null && _asc$desc !== void 0 ? _asc$desc : null, (_header$column$column5 = header.column.columnDef.meta) === null || _header$column$column5 === void 0 ? void 0 : (_header$column$column6 = _header$column$column5.renderColumnFilter) === null || _header$column$column6 === void 0 ? void 0 : _header$column$column6.call(_header$column$column5, {
                          column: header.column,
                          table: table
                        })]
                      }), header.column.getCanFilter() && (_header$column$column7 = header.column.columnDef.meta) !== null && _header$column$column7 !== void 0 && _header$column$column7.filterVariant ? /*#__PURE__*/_jsx(Box, {
                        w: "full",
                        e2eid: "Table_TableContent_v8_Box",
                        children: /*#__PURE__*/_jsx(ColumnFilter, {
                          column: header.column,
                          e2eid: "Table_TableContent_v8_ColumnFilter"
                        })
                      }) : null]
                    }));
                  })
                }, headerGroup.id);
              })
            }), /*#__PURE__*/_jsx(Tbody, {
              e2eid: "Table_TableContent_v8_Tbody",
              children: rows.length === 0 ? /*#__PURE__*/_jsx(EmptyTableRow, {
                columnsLength: columnsLength,
                e2eid: "Table_TableContent_v8_EmptyTableRow"
              }) : rows.map(function (row) {
                var _row$original2;

                var _isDisabled = !!(isDisabled || row._disable || (_row$original2 = row.original) !== null && _row$original2 !== void 0 && _row$original2._disable);

                var _lightGray = row.original._lightGray;
                return /*#__PURE__*/_jsxs(Fragment, {
                  children: [/*#__PURE__*/_jsx(Tr, {
                    e2eid: "Table_TableContent_v8_Tr",
                    children: row.getVisibleCells().map(function (cell, idx) {
                      var _cell$column$columnDe, _cell$column$columnDe2, _cell$column$columnDe3, _cell$column$columnDe4, _cell$column$columnDe5, _cell$column$columnDe6, _cell$column$columnDe7, _cell$column$columnDe8, _cell$column$columnDe9;

                      var stickyID = stickyFirstColumn ? 0 : stickyLastColumn ? columnsLength - 1 : -1;

                      var _ref5 = ((_cell$column$columnDe = cell.column.columnDef) === null || _cell$column$columnDe === void 0 ? void 0 : (_cell$column$columnDe2 = _cell$column$columnDe.meta) === null || _cell$column$columnDe2 === void 0 ? void 0 : (_cell$column$columnDe3 = _cell$column$columnDe2.getMeta) === null || _cell$column$columnDe3 === void 0 ? void 0 : _cell$column$columnDe3.call(_cell$column$columnDe2, row)) || {},
                          colspan = _ref5.colspan,
                          _ref5$skip = _ref5.skip,
                          skip = _ref5$skip === void 0 ? false : _ref5$skip;

                      if (skip) {
                        return null;
                      }

                      return /*#__PURE__*/_jsx(Td, _objectSpread(_objectSpread(_objectSpread({
                        colSpan: colspan,
                        textAlign: (_cell$column$columnDe4 = cell.column.columnDef.align) !== null && _cell$column$columnDe4 !== void 0 ? _cell$column$columnDe4 : 'left',
                        style: {
                          width: ((_cell$column$columnDe5 = cell.column.columnDef) === null || _cell$column$columnDe5 === void 0 ? void 0 : _cell$column$columnDe5.width) || cell.column.getSize(),
                          maxWidth: (_cell$column$columnDe6 = cell.column.columnDef) === null || _cell$column$columnDe6 === void 0 ? void 0 : _cell$column$columnDe6.maxWidth,
                          minWidth: (_cell$column$columnDe7 = cell.column.columnDef) === null || _cell$column$columnDe7 === void 0 ? void 0 : _cell$column$columnDe7.minWidth,
                          textAlign: textAlign
                        }
                      }, stickyFirstColumn || stickyLastColumn ? getStickyProps({
                        idx: idx,
                        isHeader: false,
                        stickyID: stickyID,
                        isDisabled: _isDisabled,
                        _lightGray: _lightGray
                      }) : getColumnProps({
                        isDisabled: _isDisabled
                      })), (_cell$column$columnDe8 = cell.column.columnDef) === null || _cell$column$columnDe8 === void 0 ? void 0 : (_cell$column$columnDe9 = _cell$column$columnDe8.meta) === null || _cell$column$columnDe9 === void 0 ? void 0 : _cell$column$columnDe9.cellProps), {}, {
                        px: 2,
                        py: 1.5,
                        e2eid: "Table_TableContent_v8_Td",
                        children: flexRender(cell.column.columnDef.cell, cell.getContext())
                      }), cell.id);
                    })
                  }), row.originalSubRows && renderSubRows(row.originalSubRows, row.index)]
                }, row.id);
              })
            })]
          })
        })]
      }), table.getFilteredRowModel().rows.length > 0 && (showTotalAmount || enablePagination) && /*#__PURE__*/_jsxs(Flex, {
        bgColor: "white",
        w: "full",
        direction: "row",
        justify: "space-between",
        rounded: "md",
        p: 0,
        e2eid: "Table_TableContent_v8_Flex",
        children: [showTotalAmount && !enablePaginationOnlyTop && /*#__PURE__*/_jsx(Text, {
          "data-test": dataTestID.generalTable.ListItemCount,
          color: mode('gray.600', 'gray.400'),
          fontSize: "sm",
          e2eid: "Table_TableContent_v8_Text",
          children: t('common:table.totalCount', "\u5171 ".concat(displayDataCount, " \u7B46\u8CC7\u6599"), {
            total: displayDataCount
          })
        }), enablePagination && !enablePaginationOnlyTop && /*#__PURE__*/_jsx(Pagination, {
          colorScheme: colorScheme,
          table: table,
          onPageChange: handlePageChange,
          e2eid: "Table_TableContent_v8_Pagination"
        })]
      })]
    })
  });
};